import React, { useState, useCallback } from 'react';
import PrivacyPolicyNotification from '../components/PrivacyPolicyNotification/PrivacyPolicyNotification';
import safeStateChanger from './SafeStateChanger';
const usePrivacyPolicy = ({
  webPlatformAdapter,
  getLocale,
  translate,
  pathFactory,
  linkUrl
}) => {
  const [privacyPolicy, setPrivacyPolicy] = useState({
    showNotification: false,
    answer: null
  });
  const handlePrivacyPolicyNotification = useCallback(() => {
    if (window.location.pathname.includes('privacy-policy')) {
      return;
    }
    // todo SW-412, endpoint should be GET instead of POST
    webPlatformAdapter.request('POST', 'rpc/show_privacy_policy', null, response => {
      setPrivacyPolicy(safeStateChanger.changeValue(privacyPolicy, 'showNotification', response.data.show));
    });
  }, [privacyPolicy, webPlatformAdapter]);
  const answerPrivacyPolicyNotification = () => {
    setPrivacyPolicy(safeStateChanger.changeValue(privacyPolicy, 'showNotification', false));
    const data = {
      answer: privacyPolicy.answer === 'yes',
      application: window.location.href,
      language: getLocale()
    };
    webPlatformAdapter.request('POST', 'rpc/accept_privacy_policy', data);
  };
  const Component = () => {
    return /*#__PURE__*/React.createElement(PrivacyPolicyComponentAux, {
      privacyPolicy: privacyPolicy,
      setPrivacyPolicy: setPrivacyPolicy,
      translate: translate,
      pathFactory: pathFactory,
      answerPrivacyPolicyNotification: answerPrivacyPolicyNotification,
      linkUrl: linkUrl
    });
  };
  return {
    PrivacyPolicyComponent: Component,
    privacyPolicy,
    setPrivacyPolicy,
    answerPrivacyPolicyNotification,
    handlePrivacyPolicyNotification
  };
};
const PrivacyPolicyComponentAux = ({
  privacyPolicy,
  setPrivacyPolicy,
  translate,
  linkUrl,
  answerPrivacyPolicyNotification
}) => {
  if (!privacyPolicy.showNotification) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(PrivacyPolicyNotification, {
    labels: {
      privacyPolicy: translate('layout.footer.links.privacy-policy'),
      yes: translate('privacy-policy.notification.yes'),
      no: translate('privacy-policy.notification.no'),
      submit: translate('form.submit')
    },
    linkUrl: linkUrl,
    answer: privacyPolicy.answer,
    onChangeAnswer: answer => setPrivacyPolicy(safeStateChanger.changeValue(privacyPolicy, 'answer', answer)),
    onSubmit: answerPrivacyPolicyNotification
  });
};
export default usePrivacyPolicy;